import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

export const BackIconComponent = ({ route, backButton }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        sessionStorage.removeItem("TrackScreen");
        if (backButton) backButton();
        else navigate(route || -1);
      }}
    >
      <ChevronLeftIcon fontSize="medium" />
    </div>
  );
};
